import gql from 'graphql-tag'

export default gql`mutation authenticateForgotPasswordConfirm($email: String!, $newpassword: String!, $confirmationCode: String!) {
	authenticateForgotPasswordConfirm(email: $email, newpassword: $newpassword, confirmationCode: $confirmationCode) {
    status
  }
}`
